// #region Imports
// #endregion
const sessionModule = {
    // #region Vars
    namespaced: true,
    // #endregion
    // #region Properties
    state: {
        currentUser: null,
        isAuthenticated: false,
        features: null,
        options: null,
        stickyMenu: null
    },
    // #endregion
    // #region getter
    getters: {
        userID(state) {
            return state.currentUser?.userId ?? '';
        },
        accountID(state) {
            return state.currentUser?.accountID ?? '';
        }
    },
    // #endregion
    // #region Mutations
    mutations: {
        startup(host) {
            //DO nothing
        },
        anonymous(state, session) {
            state.isAuthenticated = false;
            state.currentUser = undefined;
            state.features = session?.features;
            state.options = session?.options;
            state.stickyMenu = session?.stickyMenu;
        },
        loggedIn(state, user) {
            state.isAuthenticated = true;
            state.currentUser = user;
            state.features = user?.features;
            state.options = user?.options;
            state.stickyMenu = user?.stickyMenu;
        },
        setUser(state, user) {
            state.isAuthenticated = true;
            state.currentUser = user;
            state.features = user?.features;
            state.options = user?.options;
            state.stickyMenu = user?.stickyMenu;
        },
        loggedOut(state, session) {
            state.isAuthenticated = false;
            state.currentUser = undefined;
            state.features = session?.features;
            state.options = session?.options;
            state.stickyMenu = session?.stickyMenu;
        }
    },
    // #endregion
};
export default sessionModule;
